(function (){
    'use strict';
    angular.module('elogbooks.admin.labour-types', []);
})();
